// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","service":"xbjvE3PzRO8K","wrapper":"_2u5TA8rfqbMa","title":"f88xFrOZczvz"};